import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import HtaccessForm from "../../compositions/Settings/AdvancedSettings/HtaccessForm/HtaccessForm";

const FontSettings: React.FC = () => {
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()

    return (
        <>
            <Heading level={3} classes={'zr-my-4'}>
                {t('advanced.heading')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/settings')}
            >
                {t('common.backToOverview')}
            </IconButton>
            <HtaccessForm />
        </>
    )
}

export default FontSettings
